var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIphoneFrame = function SvgIphoneFrame(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fddbb7cf-8b55-4cff-8c6f-c8d86b762685",
    "data-name": "Layer 1",
    viewBox: "0 0 1504.59 1652.85",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fcbbaea4-ea7d-4d8f-9aa6-d7545f3ea11b",
    x1: 1234.84,
    y1: 1505.1,
    x2: 230.41,
    y2: 61.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b3a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3f3e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#7f8080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#888989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353535"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fa997695-6837-45e3-82ab-3eb78019720f",
    x1: 1237.37,
    y1: 1506.78,
    x2: 1242.27,
    y2: 1515.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e8e8e"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bee9c940-3f9c-446c-8f05-fad50cfda1dd",
    x1: 1298.3,
    y1: 1470.6,
    x2: 1303.2,
    y2: 1478.86,
    xlinkHref: "#fa997695-6837-45e3-82ab-3eb78019720f"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e3ff1b6d-4653-49cc-b1c5-b18ff63818b2",
    x1: 1336.04,
    y1: 1448.19,
    x2: 1340.95,
    y2: 1456.45,
    xlinkHref: "#fa997695-6837-45e3-82ab-3eb78019720f"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "af8e6f43-d801-4852-9a9f-85d16fa2a8f7",
    x1: 1355.95,
    y1: 1436.37,
    x2: 1360.86,
    y2: 1444.63,
    xlinkHref: "#fa997695-6837-45e3-82ab-3eb78019720f"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f592a1d0-c5f9-4103-a52b-d0bc4d2e17e6",
    x1: 1375.81,
    y1: 1424.58,
    x2: 1380.71,
    y2: 1432.84,
    xlinkHref: "#fa997695-6837-45e3-82ab-3eb78019720f"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf2b066f-4207-4d43-9d3d-09dbc3142a65",
    x1: 1395.62,
    y1: 1412.82,
    x2: 1400.52,
    y2: 1421.08,
    xlinkHref: "#fa997695-6837-45e3-82ab-3eb78019720f"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bfcb0eae-cc0f-4e4d-a8ee-daadbc7f8e9e",
    x1: 1415.37,
    y1: 1401.09,
    x2: 1420.28,
    y2: 1409.35,
    xlinkHref: "#fa997695-6837-45e3-82ab-3eb78019720f"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb416e2e-9d50-4a82-84d7-76ce99da42ce",
    x1: 1096.59,
    y1: 1590.37,
    x2: 1101.49,
    y2: 1598.63,
    xlinkHref: "#fa997695-6837-45e3-82ab-3eb78019720f"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a883874a-3534-461f-94ca-68f32c21a4a5",
    x1: 1117.12,
    y1: 1578.18,
    x2: 1122.02,
    y2: 1586.43,
    xlinkHref: "#fa997695-6837-45e3-82ab-3eb78019720f"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f7f62155-043e-4c5d-a7e1-50cd7536a8cd",
    x1: 1137.6,
    y1: 1566.02,
    x2: 1142.5,
    y2: 1574.27,
    xlinkHref: "#fa997695-6837-45e3-82ab-3eb78019720f"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aca9f5c6-b090-4bb6-a309-9cb2dae1e784",
    x1: 1176.14,
    y1: 1543.14,
    x2: 1181.04,
    y2: 1551.39,
    xlinkHref: "#fa997695-6837-45e3-82ab-3eb78019720f"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e8187d67-722f-471b-b313-c45701ad85fe",
    x1: -1182.41,
    y1: 999.17,
    x2: -1182.41,
    y2: 886.06,
    gradientTransform: "matrix(0.83, -0.57, 0.58, 0.84, 704.99, -807.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#282929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#313232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#494a4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#353535"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "fefdba3e-dbaa-4b82-afd7-7b6d65a53aaf",
    transform: "translate(0 -0.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.61,613.15c3.25-2.23,9,.51,12.84,6.11L300.32,695c3.83,5.6,4.31,12,1.05,14.18l-1.37.94c-3.25,2.22-9-.52-12.84-6.12L235.3,628.27c-3.84-5.6-4.31-11.95-1.06-14.18Z",
    style: {
      fill: "none"
    }
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2ce4e0a-b771-4057-9c21-c1e9e2398a01",
    x1: -1182.4,
    y1: 1153.72,
    x2: -1182.4,
    y2: 1040.6,
    xlinkHref: "#e8187d67-722f-471b-b313-c45701ad85fe"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a0a73ab4-abd8-4e77-84f4-ac1354a05f78",
    transform: "translate(0 -0.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325,743.66c3.25-2.22,9,.51,12.84,6.11l51.87,75.74c3.83,5.6,4.31,12,1.05,14.18l-1.37.94c-3.25,2.23-9-.51-12.84-6.11l-51.86-75.74c-3.84-5.6-4.31-11.95-1.06-14.18Z",
    style: {
      fill: "none"
    }
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bbc3d09e-443e-4720-9e09-3fe556b6c3c9",
    x1: -1182.41,
    y1: 824.05,
    x2: -1182.41,
    y2: 757.91,
    xlinkHref: "#e8187d67-722f-471b-b313-c45701ad85fe"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1476.91,1236.51,654.76,58.57A134.61,134.61,0,0,0,495.21,10.3L98.85,155.16c-29.24,9.46-62.58,40-75,53.18-29,31.84-34.1,91-1.14,139.73l844.35,1245a137.82,137.82,0,0,0,182.85,42.43L1435.83,1414C1472.8,1389.41,1544,1337.53,1476.91,1236.51Zm-12.35,130.15-373,221.39a133.15,133.15,0,0,1-178.22-39.83L57.31,284.23c-29.33-43.3-10.13-102.64,39-120.56L499.83,16.47A130.66,130.66,0,0,1,651.58,64.2l811.67,1157.4C1509.06,1290.92,1502.82,1344,1464.56,1366.66Z",
    transform: "translate(0 -0.99)",
    className: "frame",
    style: {
      fill: "url(#fcbbaea4-ea7d-4d8f-9aa6-d7545f3ea11b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1439.3,1353.85l-376.8,211.47a102,102,0,0,1-134.34-31.73L78.28,279.08a62.45,62.45,0,0,1,30.09-93.62L516,35.11C561.66,18.29,613.3,38,641.1,77.91L1442,1224.44C1474.33,1271.87,1492.06,1317.32,1439.3,1353.85Z",
    transform: "translate(0 -0.99)",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1463.25,1221.6,651.58,64.2A130.66,130.66,0,0,0,499.83,16.47L96.31,163.67c-49.13,17.92-68.33,77.26-39,120.56l856.08,1264a133.15,133.15,0,0,0,178.22,39.83l373-221.39C1502.82,1344,1509.06,1290.92,1463.25,1221.6Zm-24,132.25-376.8,211.47a102,102,0,0,1-134.34-31.73L78.28,279.08a62.45,62.45,0,0,1,30.09-93.62L516,35.11C561.66,18.29,613.3,38,641.1,77.91L1442,1224.44C1474.33,1271.87,1492.06,1317.32,1439.3,1353.85Z",
    transform: "translate(0 -0.99)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M690.8,1275.27h0c-5.51,3.87-12.89,2.71-16.49-2.59L594,1154.5c-3.87-5.7-1.8-13.79,4.45-17.38h0a11.51,11.51,0,0,1,15.39,3.21l80.41,118.31C697.84,1264,696.3,1271.4,690.8,1275.27Z",
    transform: "translate(0 -0.99)",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.39,1261.59a4.86,4.86,0,0,1-1.37,6.65,4.67,4.67,0,0,1-6.6-1,4.86,4.86,0,0,1,1.37-6.65A4.67,4.67,0,0,1,687.39,1261.59Z",
    transform: "translate(0 -0.99)",
    style: {
      fill: "#3f3f3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.37,1497l-66.4,38.49c-3.37,2-6.46,1.57-6.9-.86h0c-.44-2.44,1.94-6,5.32-8l66.52-38.53c3.35-1.94,6.39-1.52,6.79.93h0C1280.1,1491.54,1277.71,1495.09,1274.37,1497Z",
    transform: "translate(0 -0.99)",
    style: {
      fill: "url(#fa997695-6837-45e3-82ab-3eb78019720f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308.21,1472.58c.41,2.63-2.16,6.45-5.74,8.53s-6.84,1.64-7.27-1,2.15-6.47,5.75-8.55S1307.79,1469.94,1308.21,1472.58Z",
    transform: "translate(0 -0.99)",
    style: {
      fill: "url(#bee9c940-3f9c-446c-8f05-fad50cfda1dd)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1346.16,1450.59c.39,2.64-2.18,6.45-5.75,8.52s-6.79,1.61-7.19-1,2.17-6.46,5.75-8.54S1345.76,1447.94,1346.16,1450.59Z",
    transform: "translate(0 -0.99)",
    style: {
      fill: "url(#e3ff1b6d-4653-49cc-b1c5-b18ff63818b2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1366.18,1439c.38,2.64-2.19,6.45-5.75,8.52s-6.77,1.6-7.16-1,2.19-6.46,5.75-8.53S1365.79,1436.34,1366.18,1439Z",
    transform: "translate(0 -0.99)",
    style: {
      fill: "url(#af8e6f43-d801-4852-9a9f-85d16fa2a8f7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.14,1427.42c.38,2.64-2.2,6.45-5.75,8.51s-6.74,1.59-7.12-1.06,2.2-6.46,5.76-8.52S1385.77,1424.77,1386.14,1427.42Z",
    transform: "translate(0 -0.99)",
    style: {
      fill: "url(#f592a1d0-c5f9-4103-a52b-d0bc4d2e17e6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1406.06,1415.88c.36,2.65-2.21,6.45-5.76,8.51s-6.71,1.57-7.08-1.08,2.21-6.46,5.76-8.52S1405.7,1413.22,1406.06,1415.88Z",
    transform: "translate(0 -0.99)",
    style: {
      fill: "url(#bf2b066f-4207-4d43-9d3d-09dbc3142a65)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425.92,1404.37c.35,2.65-2.22,6.45-5.75,8.5s-6.69,1.57-7.05-1.08,2.22-6.47,5.76-8.52S1425.57,1401.71,1425.92,1404.37Z",
    transform: "translate(0 -0.99)",
    style: {
      fill: "url(#bfcb0eae-cc0f-4e4d-a8ee-daadbc7f8e9e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.39,1590.1c.53,2.61-2,6.45-5.71,8.58s-7.1,1.76-7.63-.85,2-6.46,5.71-8.6S1104.86,1587.48,1105.39,1590.1Z",
    transform: "translate(0 -0.99)",
    style: {
      fill: "url(#bb416e2e-9d50-4a82-84d7-76ce99da42ce)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126,1578.13c.51,2.62-2,6.46-5.71,8.59s-7.08,1.74-7.6-.87,2-6.47,5.72-8.6S1125.52,1575.52,1126,1578.13Z",
    transform: "translate(0 -0.99)",
    style: {
      fill: "url(#a883874a-3534-461f-94ca-68f32c21a4a5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.63,1566.2c.5,2.62-2.05,6.46-5.72,8.58s-7,1.73-7.55-.89,2.05-6.46,5.72-8.59S1146.13,1563.58,1146.63,1566.2Z",
    transform: "translate(0 -0.99)",
    style: {
      fill: "url(#f7f62155-043e-4c5d-a7e1-50cd7536a8cd)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.38,1543.75c.48,2.62-2.08,6.46-5.73,8.57s-7,1.7-7.48-.92,2.07-6.46,5.72-8.57S1184.89,1541.13,1185.38,1543.75Z",
    transform: "translate(0 -0.99)",
    style: {
      fill: "url(#aca9f5c6-b090-4bb6-a309-9cb2dae1e784)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.61,615l51.87,75.74h0l.07.12a5.07,5.07,0,0,1,.36.54,2.17,2.17,0,0,1,.19.33l.13.18c.09.16.19.33.27.5l.24.42a0,0,0,0,1,0,0l0,0c.08.15.17.32.24.47s.15.33.23.48a.07.07,0,0,0,0,.06s0,0,0,.06a2.17,2.17,0,0,1,.15.35c.08.15.13.3.2.46a.64.64,0,0,1,.05.17.93.93,0,0,1,.05.1,1.46,1.46,0,0,0,.07.19c.05.15.11.32.17.47s0,.2.08.3a.25.25,0,0,1,0,.07.29.29,0,0,1,0,.1c.05.15.09.31.14.47s.07.28.1.43a0,0,0,0,0,0,0h0c0,.17.07.33.09.48s.07.35.09.5h0c0,.18.05.34.07.52s0,.26,0,.39v.17c0,.2,0,.4,0,.58s0,.11,0,.16a1,1,0,0,1,0,.24v.28a2.13,2.13,0,0,0,0,.25c0,.14,0,.26,0,.38s0,.12,0,.17a.47.47,0,0,1,0,.16c-.06.29-.11.55-.19.81l-.06.23a5.86,5.86,0,0,1-.39.88.82.82,0,0,1-.11.17,3.55,3.55,0,0,1-.43.61l-.16.2a4.09,4.09,0,0,1-.7.61l-6.16,4.22a4,4,0,0,0,.7-.61c.05-.07.11-.13.15-.2a3.78,3.78,0,0,0,.44-.61,1,1,0,0,0,.11-.17,5.86,5.86,0,0,0,.39-.88,2,2,0,0,1,.06-.23,6.66,6.66,0,0,0,.18-.8l.06-.34c0-.12,0-.24,0-.37s0-.36,0-.54a1.91,1.91,0,0,0,0-.24c0-.26,0-.53,0-.8a.2.2,0,0,0,0-.11c0-.3-.05-.6-.09-.91h0c-.05-.32-.11-.65-.19-1,0,0,0,0,0,0-.08-.32-.16-.66-.27-1a.25.25,0,0,0,0-.07c-.09-.31-.21-.63-.33-1a.26.26,0,0,0,0-.1c-.11-.32-.26-.65-.4-1,0,0,0-.05,0-.06-.15-.34-.33-.69-.51-1,0,0,0,0,0,0-.18-.33-.37-.66-.57-1L301,696q-.29-.5-.63-1h0l-51.87-75.74c-.2-.29-.42-.58-.64-.85l-.15-.22-.29-.36c-.2-.24-.39-.46-.6-.69l-.31-.33c-.21-.23-.43-.46-.65-.66l-.3-.3c-.38-.35-.78-.68-1.17-1-.15-.12-.32-.23-.47-.34s-.25-.18-.37-.26l-.78-.5a.91.91,0,0,1-.13-.08l-.69-.35a.57.57,0,0,1-.13-.08l-.76-.32-.11,0c-.25-.09-.51-.18-.76-.25l-.08,0-.77-.16h-.06a5.18,5.18,0,0,0-.78-.09h0a5.94,5.94,0,0,0-.74,0h-.07a5,5,0,0,0-.65.13l-.07,0a5.32,5.32,0,0,0-.64.23l-.07,0a4.56,4.56,0,0,0-.6.34l6.26-4.29c.12-.06.25-.15.38-.2a2.21,2.21,0,0,1,.35-.16l.35-.13.13,0,.08,0,.13,0,.35-.07.17,0H244l.34,0h.34c.13,0,.24,0,.36,0a2.71,2.71,0,0,1,.37.05h.09l.26,0a3.75,3.75,0,0,1,.39.09l.2,0,.19.06.43.13.14.06.11,0,.19.08.48.21.09,0,.14.08.3.15a2.82,2.82,0,0,1,.38.21.4.4,0,0,1,.13.07s.05,0,.06,0a7,7,0,0,1,.68.43l.06,0,.34.25a4.73,4.73,0,0,1,.43.31s0,0,.05,0a13.62,13.62,0,0,1,1.17,1s.09.07.12.11l.19.18c.22.21.44.44.64.65a2.08,2.08,0,0,0,.21.21l.11.15c.2.22.39.44.59.68a2.12,2.12,0,0,1,.21.27s.06,0,.09.09a1.59,1.59,0,0,0,.15.21c.09.13.2.26.29.38S254.5,614.86,254.61,615Z",
    transform: "translate(0 -0.99)",
    style: {
      fill: "url(#e8187d67-722f-471b-b313-c45701ad85fe)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09,618.15,302,693.87c3.84,5.61,4,12.19.32,14.69l-1.54,1.06c-3.65,2.5-9.73,0-13.58-5.62l-51.86-75.72c-3.83-5.6-4-12.19-.32-14.7l1.53-1.05C240.16,610,246.25,612.55,250.09,618.15Z",
    transform: "translate(0 -0.99)",
    style: {
      fill: "#717171"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,745.54l51.87,75.74h0l.07.12a6.33,6.33,0,0,1,.36.54,2.17,2.17,0,0,1,.19.33l.13.18c.09.16.19.34.27.5l.24.42a.09.09,0,0,1,0,0l0,0c.08.15.17.32.24.48l.23.48a.06.06,0,0,0,0,.05s0,0,0,.06a2.17,2.17,0,0,1,.15.35c.08.15.13.3.2.46a.77.77,0,0,1,.05.17.93.93,0,0,1,.05.1,1.18,1.18,0,0,0,.07.2c.05.15.11.31.17.46s.05.21.08.3a.31.31,0,0,1,0,.08s0,.06,0,.09.09.31.14.47.07.28.1.43a0,0,0,0,0,0,0h0c0,.17.07.33.09.48s.07.35.09.5v0c0,.17.05.34.07.51s0,.26,0,.39v.18c0,.19,0,.39,0,.58s0,.1,0,.15a1,1,0,0,1,0,.25,2.61,2.61,0,0,0,0,.28,2.24,2.24,0,0,0,0,.24c0,.14,0,.26,0,.38s0,.12,0,.17a.56.56,0,0,1,0,.17c-.06.28-.11.54-.19.8l-.06.23a5.86,5.86,0,0,1-.39.88.62.62,0,0,1-.11.17,3.2,3.2,0,0,1-.43.61l-.16.2a4.09,4.09,0,0,1-.7.61l-6.16,4.22a4.44,4.44,0,0,0,.7-.61l.15-.19a4.37,4.37,0,0,0,.44-.62.71.71,0,0,0,.11-.17,5.86,5.86,0,0,0,.39-.88c0-.07,0-.15.06-.23a6.66,6.66,0,0,0,.18-.8l.06-.33c0-.13,0-.25,0-.38s0-.36,0-.53a2.08,2.08,0,0,0,0-.25c0-.26,0-.53,0-.8a.2.2,0,0,0,0-.11q0-.45-.09-.9v0c0-.32-.11-.65-.19-1,0,0,0,0,0,0-.08-.32-.16-.66-.27-1a.31.31,0,0,0,0-.08c-.09-.31-.21-.63-.33-.95a.25.25,0,0,0,0-.11c-.11-.31-.26-.64-.4-1,0,0,0,0,0-.06-.15-.34-.33-.69-.51-1a0,0,0,0,1,0,0q-.27-.5-.57-1l-.07-.11q-.29-.5-.63-1h0l-51.87-75.74c-.2-.29-.42-.57-.64-.85l-.15-.22-.29-.36c-.2-.23-.39-.46-.6-.69l-.31-.33c-.21-.23-.43-.46-.65-.66l-.3-.29c-.38-.36-.78-.69-1.17-1-.15-.12-.32-.23-.47-.33l-.37-.27-.78-.5-.13-.07q-.35-.2-.69-.36l-.13-.07c-.27-.12-.51-.23-.76-.32l-.11,0c-.25-.09-.51-.18-.76-.25l-.08,0-.77-.16h-.06a6.87,6.87,0,0,0-.78-.08h0c-.26,0-.5,0-.74,0H327c-.22,0-.43.08-.65.13l-.07,0a5.32,5.32,0,0,0-.64.23l-.07,0c-.2.11-.4.21-.6.34l6.26-4.28a2.82,2.82,0,0,1,.38-.21L332,739l.35-.13.13,0,.08,0,.13,0,.35-.06a.74.74,0,0,1,.17,0s.05,0,.07,0h.08c.12,0,.23,0,.34,0l.31,0h0l.36,0,.37,0h.09l.26,0c.14,0,.27.07.39.09l.2,0,.19.06c.15,0,.29.08.43.14l.14,0,.11,0,.19.07a5.11,5.11,0,0,1,.48.22l.09,0,.14.07.3.15c.13.06.26.14.38.21a.4.4,0,0,1,.13.07l.06,0c.23.14.46.27.68.43l.06,0a3.85,3.85,0,0,1,.34.26,4.67,4.67,0,0,1,.43.3s0,0,.05,0a12.14,12.14,0,0,1,1.17,1s.09.06.12.1.13.14.19.18c.22.21.44.44.64.66l.21.21c0,.05.08.09.11.14.2.22.39.45.59.68l.21.27a.38.38,0,0,1,.09.09,1.59,1.59,0,0,0,.15.21l.29.39C343.77,745.22,343.88,745.38,344,745.54Z",
    transform: "translate(0 -0.99)",
    style: {
      fill: "url(#f2ce4e0a-b771-4057-9c21-c1e9e2398a01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.47,748.66l51.86,75.72c3.84,5.62,4,12.19.32,14.7l-1.54,1c-3.65,2.5-9.73,0-13.58-5.62l-51.86-75.72c-3.83-5.6-4-12.19-.32-14.69l1.53-1.06C329.54,740.54,335.63,743.06,339.47,748.66Z",
    transform: "translate(0 -0.99)",
    style: {
      fill: "#6a6a69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.68,502.69,208,547h0l0,.07a2.92,2.92,0,0,1,.21.32,1.86,1.86,0,0,1,.1.2l.07.11c0,.1.11.2.15.3l.12.26s0,0,0,0h0a1.57,1.57,0,0,1,.12.3l.1.3s0,0,0,0,0,0,0,0a1.42,1.42,0,0,1,.07.22c0,.1,0,.2.08.29s0,.09,0,.12l0,.06a.43.43,0,0,0,0,.12l.06.31c0,.06,0,.13,0,.19s0,0,0,.06,0,0,0,.06a1.48,1.48,0,0,1,0,.31,2.53,2.53,0,0,1,0,.28s0,0,0,0h0c0,.12,0,.22,0,.33s0,.23,0,.34h0c0,.12,0,.23-.05.36a2.51,2.51,0,0,1,0,.27v.07a.43.43,0,0,0,0,0l-.09.41,0,.12a.55.55,0,0,1,0,.17l-.05.2-.08.18c0,.1-.07.2-.1.28a.75.75,0,0,1-.06.13.61.61,0,0,1,0,.12c-.11.22-.21.42-.32.62l-.1.17a6.09,6.09,0,0,1-.51.71.81.81,0,0,1-.12.14,6,6,0,0,1-.49.52l-.18.18a8.36,8.36,0,0,1-.73.57L200,561.17a7.83,7.83,0,0,0,.72-.57c.06-.06.13-.12.17-.17a5,5,0,0,0,.5-.53l.13-.14a6.09,6.09,0,0,0,.51-.71,1.06,1.06,0,0,1,.1-.17c.11-.2.21-.4.31-.61l.11-.25a1.9,1.9,0,0,0,.1-.28c.05-.12.09-.26.14-.39s0-.11,0-.17.09-.38.13-.58a.2.2,0,0,0,0-.07c0-.21.07-.42.1-.63h0c0-.22,0-.45,0-.67a0,0,0,0,1,0,0,4.74,4.74,0,0,0-.05-.65s0,0,0-.06c0-.2-.06-.41-.1-.62a.13.13,0,0,0,0-.06c0-.21-.1-.42-.16-.63,0,0,0,0,0,0a5.55,5.55,0,0,0-.24-.64s0,0,0,0c-.09-.2-.19-.41-.3-.61l0-.06a6.08,6.08,0,0,0-.35-.59h0l-30.32-44.29a6,6,0,0,0-.39-.49l-.09-.12-.18-.2c-.13-.14-.25-.26-.39-.39l-.2-.17a3.55,3.55,0,0,0-.44-.35l-.21-.15a7.4,7.4,0,0,0-.82-.49l-.34-.15-.27-.12-.58-.2-.1,0a4.87,4.87,0,0,0-.52-.12l-.11,0c-.2,0-.4-.07-.59-.08h-.09c-.2,0-.41,0-.61,0h-.07l-.64,0h0a5,5,0,0,0-.66.1h0c-.23.05-.44.11-.65.17h-.06c-.2.06-.39.14-.59.22l-.07,0-.6.28-.06,0c-.19.11-.39.22-.58.35l6.25-4.28c.12-.07.25-.16.37-.22l.33-.19.33-.16.12,0,.08,0,.12,0,.31-.12.15-.05.07,0,.07,0,.3-.08.27-.06h0l.3-.06.31,0h.08l.22,0h.63l.35,0h.2a.39.39,0,0,1,.15,0l.37.05h.08l.1,0,.23,0,.29.08a.35.35,0,0,1,.11,0h0l.51.18h0c.08,0,.17.07.25.12l.31.13a0,0,0,0,1,0,0,5.66,5.66,0,0,1,.83.49s.07,0,.08.05l.13.1.43.34.14.11.07.08.38.38a1,1,0,0,1,.13.15s0,0,0,.05l.1.12c0,.07.12.14.17.22S177.61,502.6,177.68,502.69Z",
    transform: "translate(0 -0.99)",
    style: {
      fill: "url(#bbc3d09e-443e-4720-9e09-3fe556b6c3c9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.33,561.35h0a9.08,9.08,0,0,1-12.59-2.5L159.29,517.3a9.08,9.08,0,0,1,2.21-12.64h0a9.09,9.09,0,0,1,12.59,2.51l28.45,41.54A9.08,9.08,0,0,1,200.33,561.35Z",
    transform: "translate(0 -0.99)",
    style: {
      fill: "#7f8080"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M277,193.5l160.09-59.74A26.91,26.91,0,0,0,449.81,93.2L430.45,65.34a3.07,3.07,0,0,0-3.59-1.12l-223.5,83.4a3.06,3.06,0,0,0-1.46,4.6l15.34,22.38A50.91,50.91,0,0,0,277,193.5Z",
    transform: "translate(0 -0.99)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M203.62,154.72s-1.69-4.87-9.62-1.94,9.62-3.55,9.62-3.55Z",
    transform: "translate(0 -0.99)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M433.11,69.18s-3.08-3.45,2.18-5.39L426,67.39Z",
    transform: "translate(0 -0.99)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIphoneFrame, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iphone-frame.0711a8d9.svg";
export { ForwardRef as ReactComponent };